// Stable bridge module for TS resolver edge-cases in tests/editor.
// Importers can use './HabitTracker' and resolve this .ts file first.
// eslint-disable-next-line @typescript-eslint/no-var-requires
const HabitTracker = require('./HabitTracker.tsx').default;

export default HabitTracker;
